import { CallLogs } from '@/features/customers/components/CallLogs';
import { LeadContext } from '@/features/leads/contexts/LeadContext';
import { useContext } from 'react';

export const CallsTab = () => {
  const { lead } = useContext(LeadContext);

  if (!lead) return <>Loading...</>;

  if (!lead.customer) return <>No customer found.</>;

  return <CallLogs customer={lead.customer} location={lead.franchise_id} />;
};
